import { Component, OnInit } from '@angular/core';
import { PlayerService } from '../../services/player.service';
import { Router } from '@angular/router';
import { Player } from '../../objects/player';
import { Group } from '../../objects/group';
import { GroupService } from '../../services/group.service';
import { isValidEmail } from '../../shared/validators/email.validator';
import { isValidUsPhone, normalizeUsPhone } from '../../shared/validators/phone.validator';

@Component({
  selector: 's18-boss-golf',
  templateUrl: './boss-golf.component.html',
  styleUrls: ['./boss-golf.component.scss']
})
export class BossGolfComponent implements OnInit {
  fName: string;
  lName: string;
  email: string;
  phone: string;
  registerError: string;
  constructor(
    private playerService: PlayerService,
    private groupService: GroupService,
    private router: Router
  ) { }

  ngOnInit() {
  }

  register(){
    // WI 58: require a valid email AND a valid phone before creating the player.
    if (!isValidEmail(this.email) || !isValidUsPhone(this.phone)) {
      this.registerError = "Enter a valid email and a valid 10-digit US phone number.";
      return;
    }
    this.registerError = "";
    this.playerService.registerWithEmail(this.email, this.fName, this.lName, "0", this.lName, normalizeUsPhone(this.phone))
      .subscribe( resp => {
        this.login();
      });
  }

  login(){
    this.playerService.login(this.email, this.lName)
      .subscribe( resp => {
        var player : Player = JSON.parse(resp.d)[0];
        this.playerService.setLoggedInPlayerInfo(player);
        this.getAdminGroups(player);
      });
  }

  getAdminGroups(player){
    this.playerService.getAdminGroups(player.player_id.toString())
      .subscribe(resp => {
        var adminGroups : Group[] = JSON.parse(resp.d).groups;
        this.groupService.setAdminGroups(adminGroups);
        this.router.navigateByUrl("/dashboard");
      });
  }

}

